<p-toast [life]="10000"></p-toast>
<router-outlet></router-outlet>
